import Joi from 'joi';
const smallHeaderWithTextSchema = Joi.object({
  type: Joi.string().valid('smallHeaderWithText').required(),
  code: Joi.string().allow('', null).required(),
  backgroundColor: Joi.string().allow('', null).required(),
  fontColor: Joi.string().allow('', null).required(),
  title: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  buttonText: Joi.string().allow('', null).required(),
  buttonLink: Joi.string().allow('', null).required()
}).unknown(true);
export default smallHeaderWithTextSchema;